import React from 'react';
import Hero from '../components/package/Hero';
import Pricing from '../components/package/Pricing';

const Package = () => {
  return (
    <div>
      <Hero/>
      <Pricing/>
    </div>
    
  );
};

export default Package;
